import React from "react";
import { db } from "../../../firebase";

import { Form, Input, Container } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Card, CardHeader, Divider, Switch } from "@mui/material";
import { useLoadScript } from "@react-google-maps/api";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import TelegramIcon from "@mui/icons-material/Telegram";
import { crearSolicitudDeOrden } from "../../../redux/accionesUsuarioDispach";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import FadeInOut from "../../../components/animations/FadeInOut";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import useGlobalConfig from "../../../hooks/globalConfig";

require("dotenv").config();

const libraries = ["places"];
const Form_express = (props) => {
  const {siteName} = useGlobalConfig()
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_APIGOOGLEMAPS,
    libraries,
  });

  const mapRef = React.useRef();

  const panTo = React.useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(14);
  }, []);

  const dispatch = useDispatch();
  const resperror = useSelector((store) => store.usuario.error);

  //Systema Validations
  //validacions From
  const [dataDeliveryOrigen, setDataDeliveryOrigen] = React.useState(false); // Confirmacion de dastos de envío
  const [dataDeliveryTo, setDataDeliveryTo] = React.useState(false); // Confirmacion de dastos de entrega
  const [currentDataDelivery, setCurrentDataDelivery] = React.useState(false);

  const [error, setError] = React.useState(""); // evento de formulario
  const [success, setSuccess] = React.useState(""); // evento de formulario
  const [errorTo, setErrorTo] = React.useState(""); // evento de formulario
  const [successTo, setSuccessTo] = React.useState(""); // evento de formulario
  const [dispachtValue, setDispachtValue] = React.useState(""); // Suma de valor de los packetes

  //System data Orders
  const [dispachtStatusChange, setDispachtStatusChange] = React.useState(""); // Registro de cambio de estado (Tipo de estado)
  const [dispachtStatusChangeDate, setDispachtStatusChangeDate] = React.useState(""); //Registro de cambios estado (Fecha Tipo de estado)
  const [dispachtStatusNotes, setDispachtStatusNotes] = React.useState(""); //Registro de cambios estado (Comentarios de Despacho)
  const [dispachtCurrentStatus, setDispachtCurrentStatus] = React.useState("C0E");
  const [dispachtCode, setDispachtCode] = React.useState("");
  const [packageCant, setPackageCant] = React.useState("");
  const [dispachtDeliveryDate, setDeliveryDispachtDate] = React.useState("");
  const [dispachtRouteDate, setDispachtRouteDate] = React.useState("");
  //Writing Data Ordes

  const [dispachtRetirementDate, setDispachtRetirementDate] = React.useState("");
  const [packageWeight, setPackageWeight] = React.useState("");
  const [packageLength, setPackageLength] = React.useState("");
  const [packageWidth, setPackageWidth] = React.useState("");
  const [packageHeight, setPackageHeight] = React.useState("");
  const [packageValue, setPackageValue] = React.useState(1);
  //System
  const [originGeoNumAddressLat, setOriginGeoNumAddressLat] =    React.useState("");
  const [originGeoNumAddressLng, setOriginGeoNumAddressLng] =    React.useState("");
  const [origenEmail, setOrigenEmail] = React.useState("");

  //user Writing or Load Data
  const [direccionSelectA, setDireccionSelectA] = React.useState([]);

  const [toAddress, setToAddress] = React.useState("");

  const [toAdressPhone, setToAdressPhone] = React.useState("+56");
  const [toUserName, setToUserName] = React.useState("");
  const [toUserEmail, setToUserEmail] = React.useState("");
  //Saved Data Adress
  const [toAdressName, setToAdressName] = React.useState("");
  const [toAdressNumAddress, setToAdressNumAddress] = React.useState("");
  const [toAdressNumAddressTemp, setToAdressNumAddressTemp] =    React.useState("");
  const [toAdressCity, setToAdressCity] = React.useState("");
  const [toAdressComuna, setToAdressComuna] = React.useState("");
  const [toAdressRegion, setToAdressRegion] = React.useState("");
  const [toAdressCountry, setToAdressCountry] = React.useState("");
  const [toCompanyAsignament, setToCompanyAsignament] = React.useState("");
  const [toPropietary, setToPropietary] = React.useState("");
  const [toAdressComent, setToAdressComent] = React.useState("");

  //user Writing or Load Data

  const [dispachtDate, setDispachtDate] = React.useState("");
  const [originAddress, setOriginAddress] = React.useState("");

  //Saved Data Adress
  const [originAdressCity, setOriginAdressCity] = React.useState("");
  const [originAdressComuna, setOriginAdressComuna] = React.useState("");
  const [originAdressName, setOriginAdressName] = React.useState("");
  const [originAdressNumAddress, setOriginAdressNumAddress] =    React.useState("");
  const [originAdressPhone, setOriginAdressPhone] = React.useState("+56");
  const [originAdressRegion, setOriginAdressRegion] = React.useState("");
  const [originCompanyAsignament, setOriginCompanyAsignament] =    React.useState("");
  const [originPropietary, setOriginPropietary] = React.useState("");
  const [originUserName, setOriginUserName] = React.useState("");
  const [originAdressComent, setOriginAdressComent] = React.useState("");

  //Variables BICCI
  const [packageContent, setPackageContent] = React.useState([]);

  const [packageContentID, setPackageContentID] = React.useState("SKU00000000");
  const [packageContentnName, setPackageContentnName] =    React.useState("NAP00000000");
  const [packageContentDescripcion, setPackageContentDescripcion] =    React.useState("BICCI EXPRESSDISPACH");
  const [packageContentQuantity, setPackageContentQuantity] = React.useState(1);
  const [packageContentPrice, setPackageContentPrice] = React.useState(1);

  const [packageModifiers, setPackageModifiers] = React.useState([]);
  const [locations, setLocations] = React.useState([]);

  //System
  const [toGeoNumAddressLat, setToGeoNumAddressLat] = React.useState("");
  const [toGeoNumAddressLng, setToGeoNumAddressLng] = React.useState("");

  //System Response
  const [packageCode, setPackageCode] = React.useState("");
  const [servicesType, setServicesType] = React.useState("Cient BICCI EXPRESS");

  const [checkedDescripcion, setCheckedDescripcion] = React.useState(false);

  //Animaciones
  const [sussesOrder, setSussesOrder] = React.useState(false);

  const [showEditO, setShowEditO] = React.useState(false);
  const toggleShowEditO = () => setShowEditO(!showEditO);

  const [showEditD, setShowEditD] = React.useState(false);
  const toggleShowEditD = () => setShowEditD(!showEditD);

  const userUid = useSelector((store) => store.usuario.user.uid);
  const userEmail = useSelector((store) => store.usuario.user.email);
  const [reiniciandoStateServicie, setReiniciandoStateServicie] =    React.useState(false);

  React.useEffect(() => {
    const findAdresses = async (userUid) => {
      // console.log(userUid);
      try {
        const adressses = await db
          .collection(`${process.env.REACT_APP_COL_USERS}`)
          .doc(userUid)
          .collection("direcciones")
          .get();
        // console.log(adressses.docs);
        const direccionA = adressses.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        // console.log(direccionA);
        setDireccionSelectA(direccionA);
      } catch (error) {
        // console.log(error);
      }
    };
    setOrigenEmail(userEmail);
    findAdresses(userUid);
  }, []);

  const reiniciarServicios = () => {
    setDataDeliveryOrigen(false); // Confirmacion de dastos de envío
    setDataDeliveryTo(false); // Confirmacion de dastos de entrega
    setCurrentDataDelivery(false);
    setError(""); // evento de formulario
    setSuccess(""); // evento de formulario
    setErrorTo(""); // evento de formulario
    setSuccessTo(""); // evento de formulario
    setDispachtValue(""); // Suma de valor de los packetes
    //System data Orders
    setDispachtStatusChange(""); // Registro de cambio de estado (Tipo de estado)
    setDispachtStatusChangeDate(""); //Registro de cambios estado (Fecha Tipo de estado)
    setDispachtStatusNotes(""); //Registro de cambios estado (Comentarios de Despacho)
    setDispachtCurrentStatus("");
    setDispachtCode("");
    setPackageCant("");
    setDeliveryDispachtDate("");
    setDispachtRouteDate("");
    //Writing Data Ordes
    setDispachtRetirementDate("");
    setPackageWeight("");
    setPackageLength("");
    setPackageWidth("");
    setPackageHeight("");
    setPackageValue(1);
    //System
    setOriginGeoNumAddressLat("");
    setOriginGeoNumAddressLng("");

    //user Writing or Load Data

    setToAddress("");
    setToAdressPhone("+56");
    setToUserName("");
    setToUserEmail("");
    //Saved Data Adress
    setToAdressName("");
    setToAdressNumAddress("");
    setToAdressNumAddressTemp("");
    setToAdressCity("");
    setToAdressComuna("");
    setToAdressRegion("");
    setToAdressCountry("");
    setToCompanyAsignament("");
    setToPropietary("");
    setToAdressComent("");
    //user Writing or Load Data
    setDispachtDate("");
    setOriginAddress("");
    //Saved Data Adress
    setOriginAdressCity("");
    setOriginAdressComuna("");
    setOriginAdressName("");
    setOriginAdressNumAddress("");
    setOriginAdressPhone("+56");
    setOriginAdressRegion("");
    setOriginCompanyAsignament("");
    setOriginPropietary("");
    setOriginUserName("");
    setOriginAdressComent("");
    //Variables BICCI
    setPackageContent([]);
    setPackageContentID("SKU00000000");
    setPackageContentnName("NAP00000000");
    setPackageContentDescripcion("BICCI EXPRESSDISPACH");
    setPackageContentQuantity(1);
    setPackageContentPrice(1);
    setPackageModifiers([]);
    setLocations([]);
    //System
    setToGeoNumAddressLat("");
    setToGeoNumAddressLng("");
    //System Response
    setPackageCode("");
    setServicesType("Cient BICCI EXPRESS");
    setCheckedDescripcion(false);
    //Animaciones
    setShowEditO(false);
    setShowEditD(false);
    setSussesOrder(true);
  };

  const handleChangeFormControl = (e) => {
    // console.log(e);
    if (e.length > 0) {
      // console.log(direccionSelectA);
      const dirSelec = direccionSelectA.filter((item) => item.id === e);
      if (dirSelec[0]) {
        // console.log(dirSelec);
        // console.log(dirSelec[0]["adressPhone"]);
        setOriginAddress(dirSelec[0]["adressAddress"]);

        // setOriginAdressNumAddress(dirSelec)
        // setDispachtRetirementDate(dirSelec)

        setOriginAdressCity(dirSelec[0]["adressCity"]);
        setOriginAdressComuna(dirSelec[0]["adressComuna"]);
        setOriginAdressName(dirSelec[0]["adressName"]);
        setOriginAdressNumAddress(dirSelec[0]["adressNumAddress"]);
        setOriginAdressPhone(dirSelec[0]["adressPhone"]);
        setOriginAdressRegion(dirSelec[0]["adressRegion"]);
        setOriginCompanyAsignament(dirSelec[0]["companyAsignament"]);
        setOriginPropietary(userUid);
        setOriginUserName(dirSelec[0]["userName"]);
        setOriginAdressComent(dirSelec[0]["adressComent"]);

        setOriginGeoNumAddressLat(dirSelec[0]["adressGeoNumAddressLat"]);
        setOriginGeoNumAddressLng(dirSelec[0]["adressGeoNumAddressLng"]);
      }
    }
    // setDispachtRouteDate(dirSelec)
    // setSuccess(dirSelec)
  };

  const dataOrder = (e) => {
    e.preventDefault();
  };
  const limpiarFormularioa = (e) => {
    e.preventDefault();
    setOriginAdressPhone("");
    setOriginAddress("");
    setOriginAdressNumAddress("");
    setDispachtRetirementDate("");
    setDispachtRouteDate("");
    setPackageWeight("");
    setPackageLength("");
    setPackageWidth("");
    setPackageHeight("");
    setPackageValue("");
    setSuccess("");
  };
  const limpiarFormulariob = (e) => {
    e.preventDefault();
    setToUserName("");
    setToAdressPhone("");
    setToAddress("");
    toAdressNumAddress("");
    toUserEmail("");
    setSuccessTo("");
  };
  const dataOrigen = (e) => {
    e.preventDefault();
    // if(!dispachtRetirementDate.trim()){
    //   // console.log('El fecha de retiro es obligatorio') // auto cargada por el Systema
    //   setError('El fecha de retiro es obligatorio')
    //   return
    // }
    if (!originUserName.trim()) {
      // console.log("El campo contacto es obligatorio");
      setError("El campo contacto es obligatorio");
      return;
    }
    if (!originAdressPhone.trim()) {
      // console.log("Ingrese un numero telefonico");
      setError("Ingrese un numero telefonico");
      return;
    }
    if (originAdressPhone.length < 12) {
      // console.log("En el campo teléfono faltan numeros");
      setError("En el campo teléfono faltan numeros");
      return;
    }
    if (originAdressPhone.length > 12) {
      // console.log("En el campo teléfono existen numeros extra");
      setError("El campo teléfono existen numeros extra");
      return;
    }
    if (!originAddress.trim()) {
      // console.log("El campo dirección es obligatorio");
      setError("El campo dirección es obligatorio");
      return;
    }
    if (!originAdressNumAddress.trim()) {
      // console.log("El campo numero de dirección es obligatorio");
      setError("El campo numero de dirección es obligatorio");
      return;
    }
    if (!packageWeight.trim()) {
      // console.log("Indique el peso estimado");
      setError("Indique el peso estimado");
      return;
    }
    if (!packageLength.trim()) {
      // console.log("Indique el largo del paquete");
      setError("Indique el largo del paquete en centimetro");
      return;
    }
    if (!packageWidth.trim()) {
      // console.log("Indique el alto del paquete");
      setError("Indique el alto del paquete en centimetro");
      return;
    }
    if (!packageHeight.trim()) {
      // console.log("Indica el ancho del paquete");
      setError("Indica el ancho del paquete en centimetro");
      return;
    }
    // if(!packageValue.length>0){
    //    // console.log('Indica el valor estimado')
    //    setError('Indica el valor estimado')
    //    return
    //  }
    setSuccess("Datos de envío ingresados.");
    setError("");
    setDataDeliveryOrigen(true);
    dispatch(toggleShowEditO);
  };

  const dataDelyvery = (e) => {
    e.preventDefault();

    // if(!dispachtDate.trim()){
    //   // console.log('El campo contacto es obligatorio')
    //   setErrorTo('El campo contacto es obligatorio')
    //   return
    // }
    if (!toUserName.trim()) {
      // console.log("El campo contacto es obligatorio");
      setErrorTo("El campo contacto es obligatorio");
      return;
    }
    if (toUserName.length <= 2) {
      // console.log("Indique un nombre de contanto valido");
      setErrorTo("Indique un nombre de contanto valido");
      return;
    }
    if (toUserName.length >= 60) {
      // console.log("Nombre de contacto max 60 Carateres");
      setErrorTo("Nombre de contacto max 60 Carateres");
      return;
    }
    if (!toAdressPhone.trim()) {
      // console.log("Ingrese un numero telefonico");
      setErrorTo("Ingrese un numero telefonico");
      return;
    }
    if (toAdressPhone.length < 12) {
      // console.log("En el campo teléfono faltan numeros");
      setErrorTo("En el campo teléfono faltan numeros");
      return;
    }
    if (toAdressPhone.length > 12) {
      // console.log("En el campo teléfono existen numeros extra");
      setErrorTo("El campo teléfono existen numeros extra");
      return;
    }
    if (!toAddress.trim()) {
      // console.log("El campo direccíon es obligatorio");
      setErrorTo("El campo direccíon es obligatorio");
      return;
    }
    if (!toAdressNumAddress.trim()) {
      // console.log("El campo numero de direccíon es obligatorio, si no la requiere escriba NA");
      setErrorTo(
        "El campo numero de direccíon es obligatorio, si no la requiere escriba NA"
      );
      return;
    }

    setSuccessTo("Datos de destino ingresados.");
    setErrorTo("");
    setDataDeliveryTo(true);
    dispatch(toggleShowEditD);
  };
  const SendSmallPackage = (e) => {
    e.preventDefault();
    setPackageWeight("0.4");
    setPackageLength("20");
    setPackageHeight("16");
    setPackageWidth("3");
  };
  const SendSmallBox = (e) => {
    e.preventDefault();
    setPackageWeight("5");
    setPackageLength("40");
    setPackageHeight("20");
    setPackageWidth("40");
  };
  const SendMediunBox = (e) => {
    e.preventDefault();
    setPackageWeight("10");
    setPackageLength("30");
    setPackageHeight("30");
    setPackageWidth("40");
  };
  const SendBigBox = (e) => {
    e.preventDefault();
    setPackageWeight("15");
    setPackageLength("40");
    setPackageHeight("40");
    setPackageWidth("40");
  };
  const actualDispachRegister = (e) => {
    e.preventDefault();
    if (dataDeliveryOrigen) {
      if (dataDeliveryTo) {
        setCurrentDataDelivery(true);
        // console.log("Listo para enviar");
      } else {
        setShowEditD(true);
        setErrorTo("Confirme los datos de destino");
        return;
      }
    } else {
      setShowEditO(true);

      setError("Confirme los datos de Origen");
      return;
    }

    // console.log("is Enviar");
    const data = {
      uid: userUid,
      //adressName:'adressName',
      companyID: "FroY2JbeirD7B1MRYEXo",
      userName: originUserName,
      userEmail: origenEmail,
      userPhone: originAdressPhone,

      groceriesNum: 1,
      groceries_id: packageContentID,
      groceries_name: packageContentnName, //NO SOLO NUMEROS AL MENOS 2 CARACTERES ALFANUMERICOS
      groceries_description: packageContentDescripcion, //NO SOLO NUMEROS AL MENOS 2 CARACTERES ALFANUMERICOS
      groceries_quantity: packageContentQuantity,
      groceries_price: packageContentPrice,

      modifiersCant: 1,
      modifiers_Name: "Unuse",
      modifier_optionID: "1",
      modifier_optionName: "Unuse",
      modifier_optionPrice: 3,
      modifier_optionQuantity: 1,

      fromLocationlatitude: originGeoNumAddressLat,
      fromLocationlongitude: originGeoNumAddressLng,
      toLocationlatitude: toGeoNumAddressLat,
      toLocationlongitude: toGeoNumAddressLng,
      fromAddress: originAddress,
      toAddress: toAddress,
    };

    const dataEbiex = {
      //System data Orders Gestion de Operaciones
      dispachtStatusChange: dispachtStatusChange, // Registro de cambio de estado - Tipo de estado)
      dispachtStatusChangeDate: dispachtStatusChangeDate, //Registro de cambios estado - Fecha Tipo de estado)
      dispachtStatusNotes: dispachtStatusNotes, //Registro de cambios estado - Comentarios de Despacho)
      //respuestas de Bicci
      dispachtCurrentStatus: dispachtCurrentStatus,
      dispachtCode: dispachtCode, //Numero BICCI EXPRESS
      packageCant: packageCant,
      dispachtDeliveryDate: dispachtDeliveryDate,
      // Fechas de retiro y Creacion
      dispachtRouteDate: dispachtRouteDate,
      dispachtRetirementDate: dispachtRetirementDate,
      //System
      originGeoNumAddressLat: originGeoNumAddressLat,
      originGeoNumAddressLng: originGeoNumAddressLng,
      //user Writing or Load Data
      toAddress: toAddress,
      toAdressPhone: toAdressPhone,
      toUserName: toUserName,
      toUserEmail: toUserEmail,
      // IF Saved Data Adress
      toAdressName: toAdressName,
      toAdressNumAddress: toAdressNumAddress,
      toAdressNumAddressTemp: toAdressNumAddressTemp,
      toAdressCity: toAdressCity,
      toAdressComuna: toAdressComuna,
      toAdressRegion: toAdressRegion,
      toAdressCountry: toAdressCountry,
      toCompanyAsignament: toCompanyAsignament,
      toPropietary: toPropietary,
      toAdressComent: toAdressComent,
      //user Writing or Load Data
      dispachtDate: Date.now(),
      originAddress: originAddress,
      //Saved Data Adress
      originAdressCity: originAdressCity,
      originAdressComuna: originAdressComuna,
      originAdressName: originAdressName,
      originAdressNumAddress: originAdressNumAddress,
      originAdressPhone: originAdressPhone,
      originAdressRegion: originAdressRegion,
      originCompanyAsignament: originCompanyAsignament,
      originPropietary: originPropietary,
      originUserName: originUserName,
      originAdressComent: originAdressComent,
      //Variables BICCI
      packageContent: packageContent,
      packageContentID: packageContentID,
      packageContentnName: packageContentnName,
      packageContentDescripcion: packageContentDescripcion,
      packageContentQuantity: packageContentQuantity,
      packageContentPrice: packageContentPrice,
      packageModifiers: packageModifiers,
      locations: locations,
      //System
      toGeoNumAddressLat: toGeoNumAddressLat,
      toGeoNumAddressLng: toGeoNumAddressLng,
      //System Response
      packageCode: packageCode, // Respuesta de Bicci
    };
    // console.log("envío despachado");
    dispatch(crearSolicitudDeOrden(dataEbiex, data));

    function delay() {
      setReiniciandoStateServicie(true);
      reiniciarServicios();
    }
    setTimeout(delay, 3000);

    function delay2() {
      setReiniciandoStateServicie(false);
    }
    setTimeout(delay2, 5000);
  };
  const handleChangeDescripcion = (e) => {
    setCheckedDescripcion(!checkedDescripcion);

    if (checkedDescripcion === false) {
      setPackageContentID("SKU00000000");
      setPackageContentnName("NoIndica");
      setPackageContentDescripcion(`${siteName} DISPACH`);
      setPackageContentPrice(1);
    }
  };

  if (loadError) return "Error";
  if (!isLoaded) return "Loading...";

  const Cargando = () => {
    return (
      <div>
        {/* <CircularProgress /> */}

        <Container id="smallspiner" className="row">
          <div className="center-smallspiner">
            <img
              src="/ebiexlogosvg_animated.svg"
              className="smallspiner rotating"
            />
            <h3>Enviando...</h3>
          </div>
        </Container>
      </div>
    );
  };

  return reiniciandoStateServicie !== true ? (
    <Container {...props}>
      {sussesOrder !== true ? (
        <div></div>
      ) : (
        <div className="alert alert-success" role="alert">
          Se realizó la solicitud de orden con éxito
        </div>
      )}

      <Card className="typeMiniforms">
        <Form onSubmit={actualDispachRegister}>
          <div id="topControll">
            <Button
              className="btn-control"
              color={dataDeliveryOrigen ? "success" : "warning"} //success
              variant="contained"
              type="sutmit"
              onClick={toggleShowEditO}
            >
              {dataDeliveryOrigen ? (
                <CheckCircleOutlineIcon />
              ) : (
                <ModeEditIcon />
              )}
              Origen
            </Button>
            <Button
              className="btn-control"
              color={dataDeliveryTo ? "success" : "warning"}
              variant="contained"
              type="sutmit"
              onClick={toggleShowEditD}
            >
              {dataDeliveryTo ? <CheckCircleOutlineIcon /> : <ModeEditIcon />}
              Destino
            </Button>
            <Button
              id={currentDataDelivery ? "calltrap-btn" : "no-calltrap-btn"}
              className="btn-control"
              color={currentDataDelivery ? "success" : "primary"}
              variant="contained"
              type="sutmit"
              onClick={actualDispachRegister}
            >
              Crear
              <TelegramIcon
                id={currentDataDelivery ? "calltrap-ico" : "no-calltrap-ico"}
              />
            </Button>
          </div>
        </Form>

        <CardHeader
          subheader="Crea tus envíos Express o para el siguiente día"
          title={
            <>
              <Button
                className="btn-control"
                color={dataDeliveryOrigen ? "success" : "warning"}
                variant="contained"
                type="sutmit"
                onClick={toggleShowEditO}
              >
                {dataDeliveryOrigen ? (
                  <CheckCircleOutlineIcon />
                ) : (
                  <ModeEditIcon />
                )}
              </Button>
              <h2>Datos de envío</h2>
            </>
          }
        />
        <Divider />
        <FadeInOut show={showEditO} duration={500}>
          <Container className="formcontent" id="micuentafromIni">
            <hr></hr>
            {direccionSelectA.length > 0 ? (
              <Form onSubmit={dataOrigen}>
                {success ? (
                  <div className="alert alert-success">{success}</div>
                ) : null}
                {error ? (
                  <div className="alert alert-danger">{error}</div>
                ) : null}
                {resperror ? (
                  <div className="alert alert-danger">{resperror}</div>
                ) : null}
                <Form.Group widths="equal">
                  <div className="input-group mb-3">
                    <h2 id="custom-selectFromTitle">
                      Seleccione una dirección
                    </h2>
                    <select
                      id="custom-selectFrom"
                      label="Tipo de usuario"
                      control="select"
                      onChange={(e) => handleChangeFormControl(e.target.value)}
                    >
                      <option> Seleccione... </option>
                      {direccionSelectA.map((item) => (
                        <option key={item.id} value={item.id}>
                          {" "}
                          {item.adressName},{item.adressAddress}
                        </option>
                      ))}
                    </select>
                  </div>
                </Form.Group>

                <Form.Group widths="equal">
                  {/* <Form.Field
              
                    control={Label}
                    label='Fecha de retiro'
           
                    type="text"
                    
                    /> */}
                  <Form.Field
                    id="FormFieldOrigenDate"
                    control={Input}
                    label="Indique que día se puede retirar el envío en el punto Origen. "
                    placeholder="Fecha de entrega"
                    iconPosition="left"
                    type="date"
                    onChange={(e) => setDispachtRetirementDate(e.target.value)}
                    value={dispachtRetirementDate}
                  />

                  {/* 
                  <Search 
                       panTo={panTo} 
                      // setSelected={setSelected} 
                      //  setAdressAddress={setAdressAddress}
                      //  setAdressComuna ={setAdressComuna }
                      //  setAdressCity={setAdressCity}
                      //  setAdressRegion={setAdressRegion} 
                      //  setAdressCountry={setAdressCountry}
                      //  setAdressGeoNumAddressLat={setAdressGeoNumAddressLat}
                      //  setAdressGeoNumAddressLng={setAdressGeoNumAddressLng}
                       id="imputSearchFromOrigen" /> */}
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    // label='Nombre'
                    placeholder="Nombre"
                    iconPosition="left"
                    type="text"
                    onChange={(e) => setOriginUserName(e.target.value)}
                    value={originUserName}
                    icon="user"
                  />

                  <Form.Field
                    control={Input}
                    //label='Teléfono'
                    placeholder="Teléfono"
                    iconPosition="left"
                    icon="phone"
                    type="text"
                    onChange={(e) => setOriginAdressPhone(e.target.value)}
                    value={originAdressPhone}
                  />
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    // label='Nombre'
                    placeholder="Direccíon de Origen"
                    iconPosition="left"
                    type="text"
                    onChange={(e) => setOriginAddress(e.target.value)}
                    value={originAddress}
                    icon="map marker alternate"
                  />

                  <Form.Field
                    control={Input}
                    // label='Nombre'
                    placeholder="Direccíon de Origen"
                    iconPosition="left"
                    type="text"
                    onChange={(e) => setOriginAdressNumAddress(e.target.value)}
                    value={originAdressNumAddress}
                    icon="hashtag"
                  />
                </Form.Group>
                <Form.Group widths="equal">
                  <Button className="buttonpackage" onClick={SendSmallPackage}>
                    <LocalPostOfficeIcon
                      sx={{ fontSize: 40 }}
                      color="success"
                    ></LocalPostOfficeIcon>
                  </Button>
                  <Button className="buttonpackage" onClick={SendSmallBox}>
                    <ViewInArIcon
                      sx={{ fontSize: 50 }}
                      color="success"
                    ></ViewInArIcon>
                  </Button>
                  <Button className="buttonpackage" onClick={SendMediunBox}>
                    <ViewInArIcon
                      sx={{ fontSize: 60 }}
                      color="success"
                    ></ViewInArIcon>
                  </Button>
                  <Button className="buttonpackage" onClick={SendBigBox}>
                    <ViewInArIcon
                      sx={{ fontSize: 70 }}
                      color="success"
                    ></ViewInArIcon>
                  </Button>
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field
                    className="formGroup4"
                    control={Input}
                    label="Peso"
                    placeholder="Kgs"
                    iconPosition="left"
                    type="text"
                    icon="weight"
                    onChange={(e) => setPackageWeight(e.target.value)}
                    value={packageWeight}
                  />

                  <Form.Field
                    className="formGroup4"
                    control={Input}
                    label="Largo"
                    placeholder="cm"
                    iconPosition="left"
                    type="text"
                    icon="angle right"
                    onChange={(e) => setPackageLength(e.target.value)}
                    value={packageLength}
                  />

                  <Form.Field
                    className="formGroup4"
                    control={Input}
                    label="Alto"
                    placeholder="cm"
                    iconPosition="left"
                    type="text"
                    icon="angle right"
                    onChange={(e) => setPackageHeight(e.target.value)}
                    value={packageHeight}
                  />
                  <Form.Field
                    className="formGroup4"
                    control={Input}
                    label="Ancho"
                    placeholder="cm"
                    iconPosition="left"
                    type="text"
                    icon="angle right"
                    onChange={(e) => setPackageWidth(e.target.value)}
                    value={packageWidth}
                  />
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field>
                    <h4>
                      Descripción{" "}
                      <Switch
                        checked={checkedDescripcion}
                        onChange={handleChangeDescripcion}
                      />
                    </h4>
                    {checkedDescripcion ? (
                      <p>
                        <i className="info circle icon"></i>Al desactivar los
                        valores se reiniciaran
                      </p>
                    ) : null}
                  </Form.Field>
                </Form.Group>
                {checkedDescripcion ? (
                  <div>
                    <Form.Group widths="equal">
                      <Form.Field
                        control={Input}
                        label="Código"
                        placeholder="Código"
                        type="text"
                        onChange={(e) => setPackageContentID(e.target.value)}
                        value={packageContentID}
                      />
                      <Form.Field
                        control={Input}
                        label="Nombre"
                        placeholder="Nombre"
                        type="text"
                        onChange={(e) => setPackageContentnName(e.target.value)}
                        value={packageContentnName}
                      />
                    </Form.Group>
                    <Form.Group widths="equal">
                      <Form.Field
                        control={Input}
                        label="Descripción"
                        placeholder="Descripción"
                        type="text"
                        onChange={(e) =>
                          setPackageContentDescripcion(e.target.value)
                        }
                        value={packageContentDescripcion}
                      />
                      <Form.Field
                        className="formGroup2"
                        control={Input}
                        label="Valor estimado"
                        placeholder="Valor estimado"
                        iconPosition="left"
                        type="number"
                        onChange={(e) => setPackageContentPrice(e.target.value)}
                        value={packageContentPrice}
                        icon="dollar"
                      />
                    </Form.Group>
                  </div>
                ) : (
                  <span>Sin descripción del paquete</span>
                )}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    p: 2,
                  }}
                >
                  <Button
                    sx={{ margin: "2px" }}
                    type="sutmit"
                    color="primary"
                    variant="contained"
                  >
                    Confirmar!
                  </Button>
                </Box>
              </Form>
            ) : (
              <h2>
                {" "}
                Primero agrega al menos una nueva dirección o punto de retiro{" "}
              </h2>
            )}
          </Container>
        </FadeInOut>

        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
          }}
        >
          <Button
            sx={{ margin: "2px" }}
            color="primary"
            variant="contained"
            onClick={limpiarFormularioa}
          >
            <CleaningServicesIcon></CleaningServicesIcon>
            Limpiar
          </Button>
        </Box>
      </Card>

      {direccionSelectA.length > 0 ? (
        <Card className="typeMiniforms">
          <CardHeader
            subheader="Crea tus envíos Express o para el siguiente dia"
            title={
              <>
                <Button
                  className="btn-control"
                  color={dataDeliveryTo ? "success" : "warning"}
                  variant="contained"
                  type="sutmit"
                  onClick={toggleShowEditD}
                >
                  {dataDeliveryTo ? (
                    <CheckCircleOutlineIcon />
                  ) : (
                    <ModeEditIcon />
                  )}
                </Button>
                <h2>Datos de entrega</h2>
              </>
            }
          />
          <Divider />
          <FadeInOut show={showEditD} duration={500}>
            <Container className="formcontent" id="micuentafromIni">
              <hr></hr>

              <Form onSubmit={dataDelyvery}>
                {successTo ? (
                  <div className="alert alert-success">{successTo}</div>
                ) : null}
                {errorTo ? (
                  <div className="alert alert-danger">{errorTo}</div>
                ) : null}
                {resperror ? (
                  <div className="alert alert-danger">{resperror}</div>
                ) : null}

                <Form.Group widths="equal">
                  {/* <Form.Field
                id="FormFieldToDate"
                className="two wide field"
                control={Input}
                label='Programa una fecha de entrega (Opcional)'
                placeholder='Fecha de entrega'
                iconPosition='left'
                type="date"
                onChange={e => setDispachtDate(e.target.value)}
                value ={dispachtDate}
              /> */}

                  <Form.Field
                    control={Input}
                    label="Habilitará notificaciones al cliente"
                    placeholder="email (Opcional)"
                    iconPosition="left"
                    type="text"
                    onChange={(e) => setToUserEmail(e.target.value)}
                    value={toUserEmail}
                    icon="at"
                  />
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    // label='Nombre'
                    placeholder="Nombre"
                    iconPosition="left"
                    type="text"
                    onChange={(e) => setToUserName(e.target.value)}
                    value={toUserName}
                    icon="user"
                  />
                  <Form.Field
                    control={Input}
                    //label='Teléfono'
                    placeholder="Teléfono"
                    iconPosition="left"
                    icon="phone"
                    type="text"
                    onChange={(e) => setToAdressPhone(e.target.value)}
                    value={toAdressPhone}
                  />
                </Form.Group>

                <Form.Group widths="equal">
                  <Search
                    //    panTo={panTo}
                    toUserName={toUserName}
                    setToAddress={setToAddress}
                    setToAdressPhone={setToAdressPhone}
                    setToUserEmail={setToUserEmail}
                    setToAdressName={setToAdressName}
                    setToAdressNumAddress={setToAdressNumAddress}
                    setToAdressCity={setToAdressCity}
                    setToAdressCountry={setToAdressCountry}
                    setToAdressComuna={setToAdressComuna}
                    setToAdressRegion={setToAdressRegion}
                    setToCompanyAsignament={setToCompanyAsignament}
                    setToPropietary={setToPropietary}
                    setToAdressComent={setToAdressComent}
                    setToGeoNumAddressLat={setToGeoNumAddressLat}
                    setToGeoNumAddressLng={setToGeoNumAddressLng}
                    setToAdressNumAddressTemp={setToAdressNumAddressTemp}
                    id="imputSearchFromOrigen"
                  />

                  {/* <Form.Field
                  control={Input}
                  // label='Nombre'
                  placeholder='Numero de Casa O Edifcio'
                  iconPosition='left'
                  type="text"
                  onChange={e => setToAdressNumAddress(e.target.value)}
                  value ={toAdressNumAddress} 
                  icon='hashtag'
                /> */}
                  <Form.Field
                    className="formGroup3"
                    control={Input}
                    label="# Casa / Departemento"
                    placeholder="Numero"
                    iconPosition="left"
                    type="text"
                    onChange={(e) => setToAdressNumAddress(e.target.value)}
                    value={toAdressNumAddress}
                    icon="hashtag"
                  />
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field
                    className="formGroup3"
                    control={Input}
                    label="Region"
                    placeholder="Region"
                    iconPosition="left"
                    type="text"
                    onChange={(e) => setToAdressRegion(e.target.value)}
                    value={toAdressRegion}
                    icon="angle right"
                  />

                  <Form.Field
                    className="formGroup3"
                    control={Input}
                    label="Ciudad"
                    placeholder="Ciudad"
                    iconPosition="left"
                    type="text"
                    onChange={(e) => setToAdressCity(e.target.value)}
                    value={toAdressCity}
                    icon="angle right"
                  />
                  <Form.Field
                    className="formGroup3"
                    control={Input}
                    label="Comuna"
                    placeholder="Comuna"
                    iconPosition="left"
                    type="text"
                    onChange={(e) => setToAdressComuna(e.target.value)}
                    value={toAdressComuna}
                    icon="angle right"
                  />
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Field
                    className="disabled field disabledEstilo formGroup4"
                    control={Input}
                    label="Pais"
                    placeholder="Pais"
                    iconPosition="left"
                    type="text"
                    onChange={(e) => setToAdressCountry(e.target.value)}
                    value={toAdressCountry}
                    icon="globe"
                  />
                  <Form.Field
                    control={Input}
                    label="Comentario (Opcional)"
                    placeholder="Comentario breve o referencia"
                    type="TextArea"
                    onChange={(e) => setToAdressComent(e.target.value)}
                    value={toAdressComent}
                  />
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    placeholder="Direccíon de Origen"
                    iconPosition="left"
                    id="ocultarImput"
                    onChange={(e) => setToAddress(e.target.value)}
                    value={toAddress + " " + toAdressNumAddressTemp}
                  />
                </Form.Group>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    p: 2,
                  }}
                >
                  <Button
                    sx={{ margin: "2px" }}
                    type="sutmit"
                    color="primary"
                    variant="contained"
                  >
                    Confirmar!
                  </Button>
                </Box>
              </Form>
            </Container>
          </FadeInOut>
          <Divider />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              p: 2,
            }}
          >
            <Button
              sx={{ margin: "2px" }}
              color="primary"
              variant="contained"
              onClick={limpiarFormulariob}
            >
              <CleaningServicesIcon></CleaningServicesIcon>
              Limpiar
            </Button>
          </Box>
        </Card>
      ) : (
        <h2> Ve a direcciones y agrega una nueva... </h2>
      )}
    </Container>
  ) : (
    <div>
      <Cargando />
    </div>
  );
};

function Search({
  setToGeoNumAddressLng,
  setToGeoNumAddressLat,
  setToAdressNumAddressTemp,
  setToAddress,
  setToAdressCity,
  setToAdressComuna,
  setToAdressRegion,
  setToAdressCountry,
}) {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      location: { lat: () => 43.6532, lng: () => -79.3832 },
      radius: 10 * 1000,
      componentRestrictions: {
        country: "Cl",
      },
    },
  });
  // https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletionRequest
  const handleInput = (e) => {
    setValue(e.target.value);
  };
  const handleSelect = async (address) => {
    // console.log(address);
    setValue(address, false);
    clearSuggestions();
    let element = [];
    try {
      const results = await getGeocode({ address });
      // // console.log(results[0].address_components[0].long_name);
      // // console.log(results[0].address_components[1].long_name);
      // // console.log(results[0].address_components[2].long_name);
      // // console.log(results[0].address_components[3].long_name);
      // // console.log(results[0].address_components[4].long_name);
      // // console.log(results[0].address_components[5].long_name);
      // // console.log(results[0].address_components[6].long_name);
      // console.log(results[0]);
      // console.log(results[0].address_components.length);
      // console.log(results[0].address_components);
      //setToAddress(address)

      for (let i = 0; i < results[0].address_components.length; i++) {
        let elementAdress = results[0].address_components[i];
        // console.log(elementAdress["types"][0]);
        switch (elementAdress["types"][0]) {
          case "street_number":
            // console.log(elementAdress.long_name);
            setToAdressNumAddressTemp(elementAdress.long_name);
            break;
          case "route":
            // console.log(elementAdress.long_name);
            setToAddress(elementAdress.long_name);
            break;
          case "locality":
            // console.log(elementAdress.long_name);
            setToAdressComuna(elementAdress.long_name);
            break;
          case "administrative_area_level_3":
            // console.log(elementAdress.long_name);
            break;
          case "administrative_area_level_2":
            // console.log(elementAdress.long_name);
            setToAdressCity(elementAdress.long_name);
            break;
          case "administrative_area_level_1":
            // console.log(elementAdress.long_name);
            setToAdressRegion(elementAdress.long_name);
            break;
          case "country":
            // console.log(elementAdress.long_name);
            setToAdressCountry(elementAdress.long_name);

            break;
          case "postal_code":
            // console.log(elementAdress.long_name);
            break;

          default:
            break;
        }
      }

      const { lat, lng } = await getLatLng(results[0]);
      //   panTo({ lat, lng });
      //  Sin funciones
      //  markerBytext.lat= lat;
      //  markerBytext.lng=lng;

      // console.log(lat);
      // console.log(lng);
      setToGeoNumAddressLat(lat);
      setToGeoNumAddressLng(lng);
      // setSelected(markerBytext)
    } catch (error) {
      // console.log("😱 Error: ", error);
      // console.log(element);
    }
  };

  return (
    <div className="search-box-ebiex">
      <Combobox onSelect={handleSelect}>
        <ComboboxInput
          className="input-group mb-2"
          id="imputSearchFromTo"
          value={value}
          onChange={handleInput}
          disabled={!ready}
          placeholder="Busca tu ubicación"
        />

        <ComboboxPopover className="comboboxList-ebiex">
          <ComboboxList key={Math.random().toString()}>
            {status === "OK" &&
              data.map(({ id, description }) => (
                <ComboboxOption
                  key={Math.random().toString()}
                  value={description}
                  className="dropdown-item dropdown-ebiex"
                />
              ))}
          </ComboboxList>
        </ComboboxPopover>
      </Combobox>
    </div>
  );
}

export default Form_express;
